// @flow

import { daysFromNow, formatTimeSpan } from '@zapier/date';

import { AUTHS_URL } from 'app/dashboard/utils/constants';

type ZapWarningComponentProps = {
  tagMsg: string,
  msg: string,
  linkUrl: string,
  linkText: string,
};

/**
 * Used in ZapWarning component
 */
export const getPropsForZapWarning = ({
  staleAuthServiceNamesByZap,
}: {
  staleAuthServiceNamesByZap: string[],
}) => {
  const numOfStaleAuth = staleAuthServiceNamesByZap.length;

  return ({
    tagMsg: 'expired auth',
    msg: `${
      numOfStaleAuth > 1
        ? 'Your accounts have expired.'
        : `Your ${staleAuthServiceNamesByZap[0]} account has expired.`
    }`,
    linkUrl: AUTHS_URL,
    linkText: 'Please reconnect here.',
  }: ZapWarningComponentProps);
};

export const getDaysRemainingMessage = (
  heldTasksStartsExpiringOn: string,
  sameExpirationDate?: boolean
) => {
  const totalDaysBetween = daysFromNow(heldTasksStartsExpiringOn);

  const daysRemainText = formatTimeSpan(
    Date.now(),
    heldTasksStartsExpiringOn,
    false
  );

  const msg = `${
    totalDaysBetween > 1 ? 'remain' : 'remains'
  } until we discard ${
    // Check for false since we only want the 'some' wording on top Held Task banner (this function is shared by both Zap Warning and Held Task banner)
    sameExpirationDate === false ? 'some of them' : 'them'
  }.`;

  return {
    daysRemainText,
    msg,
  };
};
